<template>
  <div class="examineinfo">
    <Stance
      v-if="code != '0'"
      type="general"
      :btn-text="btnText"
      :show-info="false"
      :descText="msg"
      :show-btn="true"
      @click="btnClick"
    />

    <div v-if="code == '0'" class="form">
      <div class="commit-info">
        <section class="guide-info">
          <div class="main">{{ guideTitle }}</div>
        </section>
        <section class="product-info" v-show="!loading">
          <div class="title">
            <span>与当前保证金相关的订单信息</span>
            <!-- <span class="orderDetial"
                  @click="goToDetial()">订单信息</span> -->
          </div>
          <div class="user">
            <div class="avatar">
              <div
                class="avatars"
                @click="goToProfileDetial()"
                :style="{ backgroundImage: 'url(' + $setPicSize(info.avatar) + ')' }"
              />
            </div>
            <span class="nickName" @click="goToProfileDetial()">{{
              info.buyerNickName.length > 10
                ? info.buyerNickName.slice(0, 10) + '...'
                : info.buyerNickName
            }}</span>
            <span class="status">{{ info.orderStatus }}</span>
          </div>
          <div class="info">
            <div class="pic" @click="goToDetial()">
              <div
                class="pic-core"
                :style="{ backgroundImage: 'url(' + $setPicSize(info.infoPic) + ')' }"
              />
            </div>
            <div class="left-info">
              <div class="left-info-title">
                商品标题：<span>{{ info.infoTitle }}</span>
              </div>
              <div class="left-info-title">
                下单时间：<span>{{ info.orderTime }}</span>
              </div>
              <div class="left-info-title">
                订单金额：<span>{{ info.orderAmount }}</span>
              </div>
              <div class="left-info-title">
                保证金ID：<span class="copy-link" :data-clipboard-text="info.depositId">{{
                  info.depositId
                }}</span>
              </div>
              <div class="left-info-title">
                保证金金额：<span>{{ info.depositAmount }}</span>
              </div>
            </div>
          </div>
        </section>
        <!-- 事件描述 -->
        <section class="basic-info">
          <div class="title">事件描述</div>
          <div class="item">
            <textarea
              class="desc"
              id="desc"
              maxlength="200"
              ref="textArea"
              @focus="intoAreaView"
              @blur="txtBoxBlur"
              v-model="desc"
              placeholder="请填写买家恶意行为的文字说明（必填）"
            ></textarea>
            <span class="desc-length">{{ remainDescLength }}</span>
          </div>
        </section>
        <!-- 上传凭证 -->
        <section class="basic-info">
          <div class="title">上传凭证</div>
          <div class="detial">{{ uploadphoto }}</div>
          <div class="photo">
            <z-upload
              v-model="pics"
              ref="upload"
              weixin
              :process-file="processFile"
              accept="image/*"
              :max="6"
            />
          </div>
        </section>
      </div>
      <div
        class="form-bottom"
        @click="nextTip()"
        :class="{ 'form-disabled': !canSubmit, 'form-selected': canSubmit }"
      >
        <div class="form-bottom-text">提交</div>
      </div>
    </div>
  </div>
</template>

<script>
import ClipboardJS from 'clipboard'
import native from '@zz-common/native-adapter'
import setPicSize from '@zz-app/setPicSize'
import compress from '@zz-common/zz-ui/lib/utils/image'
import { Stance, Toast, Upload, Dialog } from '@zz-common/zz-ui'
import { lego } from '@zz-common/lego'
import { getdepositinfo, depositsubmit } from '@api/resourceApi'

import { toast } from '../../native'
import copy from '../../lib/copy'
import {
  queryParams,
  getCookie,
  tranPics
} from '../../lib/utils'

const MAX_DESC_LENGTH = 200
const query = queryParams()

export default {
  name: 'examineInfo',
  data() {
    return {
      infoId: query.infoId || this.$route.query.infoId,
      orderId: query.orderId || this.$route.query.orderId,
      depositId: query.depositId || this.$route.query.depositId,
      loading: false,
      guideTitle: '请按照提示完成以下信息验证',
      uploadphoto: '请上传体现买家恶意行为的聊天截图等信息（选填，最多6张）',
      btnTxt: '确定',
      btnText: '返回',
      desc: '',
      descLength: 0,
      oneSubmit: true,
      pics: [],
      // action: { target: 'https://upload.58cdn.com.cn/json?rand=0.1928', zz: true },
      info: {
        buyerNickName: '',
        orderStatus: '',
        infoTitle: '',
        orderTime: '',
        orderAmount: '',
        depositId: '',
        depositAmount: '',
        title: '',
        infoPic: '',
        avatar: ''
      },
      code: '0',
      msg: '好像出了点小问题'
    }
  },
  computed: {
    canSubmit() {
      return this.desc !== ''
    },
    remainDescLength() {
      return this.desc.length + '/' + MAX_DESC_LENGTH
    }
  },
  methods: {
    processFile(file, next) {
      compress(
        file,
        {
          compress: true // 开启图片压缩，提高上传的速度，同时修正图片方向修正的问题
        },
        next
      )
    },
    $setPicSize(url) {
      return setPicSize(url, 300, 300)
    },
    init() {
      lego.send({
        pagetype: 'ZZUP_BONDINSPECTION',
        actiontype: 'PAGE_SHOW',
        backup: {
          infoId: this.infoId,
          depositId: this.depositId,
          orderId: this.orderId
        }
      })
      return this.getbondcheckproduct()
    },
    btnClick() {
      native.close()
    },
    quit() {},
    goToDetial() {
      native.wrap('enterOrderDetail')({
        orderId: this.orderId,
        from: 'm'
      })
    },
    goToProfileDetial() {
      if (!this.info.buyerUid) return ''
      native.wrap('enterProfile')({
        userId: this.info.buyerUid,
        from: 'm'
      })
    },
    getbondcheckproduct() {
      this.loading = true
      const params = {}
      if (this.infoId) params.infoId = this.infoId
      if (this.orderId) params.orderId = this.orderId
      if (this.depositId) params.depositId = this.depositId
      return getdepositinfo({ ...params })
        .then((respData) => {
          console.log('---respData', respData)
          this.loading = false
          const { status = '', msg = '', data = {} } = respData
          this.code = status
          this.msg = msg
          this.info = { ...data }
          return respData
        })
        .catch((err) => {
          this.loading = false
          this.code = ''
          this.msg = '获取申诉信息错误'
          toast({
            msg: err.message || '获取申诉信息错误',
            style: '2'
          })
        })
    },
    nextTip() {
      if (!this.desc) return toast({ msg: '请填写事件描述后再提交', style: '2' })
      if (!this.canSubmit) return ''
      if (!this.oneSubmit) return ''
      const uploadStatus = this.$refs.upload.isComplete()
      console.log('上传2状态', this.$refs.upload.isComplete())
      if (!uploadStatus) return Toast('图片上传中，请上传完成再提交')
      if (this.info.submitCount === '1') return this.showTip() //已提交次数超过两次 展示校验弹窗
      this.oneSubmit = false
      return this.submit()
    },
    showTip() {
      Dialog.confirm({
        message: '若本次申诉失败，保证金将赔付至买家，请您谨慎填写',
        lineFeed: false,
        confirmButtonText: '确定提交',
        cancelButtonText: '返回修改'
      })
        .then(() => {
          // on confirm
          this.oneSubmit = false
          this.submit()
        })
        .catch(() => {
          // on cancel
        })
    },
    Uploaded(rst, order) {
      this.evidence.splice(order - 1, 1, rst)
      this.evidence.map((item) => console.log('img', item))
    },
    copyValue() {
      console.log('this.info.depositId', this.info.depositId)
      copy('.depositId')
      Toast('保证金ID复制成功')
    },
    txtBoxBlur() {
      setTimeout(() => {
        document.body.scrollTop = document.body.scrollHeight
      }, 100)
    },
    intoInputView() {
      console.log('input focous----')
      console.log('this.$refs.input----', this.$refs.input)
      setTimeout(() => {
        this.$refs.input.scrollIntoView()
      }, 300)
    },
    intoAreaView() {
      console.log('textArea focous----')
      console.log('this.$refs.textArea----', this.$refs.textArea)
      setTimeout(() => {
        this.$refs.textArea.scrollIntoView()
      }, 300)
    },
    submit() {
      const params = {
        depositId: this.depositId,
        orderId: this.orderId,
        infoId: this.infoId,
        appealReason: this.desc,
        picList: tranPics(this.pics).join('|')
      }
      lego.send({
        pagetype: 'ZZUP_BONDINSPECTION',
        actiontype: 'CLICK',
        backup: {
          infoId: this.infoId,
          depositId: this.depositId,
          uid: getCookie('uid'),
          orderId: this.orderId
        }
      })
      depositsubmit(params)
        .then((res) => {
          lego.send({
            pagetype: 'ZZUP_BONDINSPECTION',
            actiontype: 'SUBMIT_SUCCESS',
            backup: {
              uid: getCookie('uid')
            }
          })
          this.oneSubmit = true //等接口返回数据后可以再次提交
          const { status = '', msg = '' } = res
          if (status !== '0') return Toast(msg)
          Toast.success('提交成功')
          //  提交成功后 2s 关闭页面
          setTimeout(() => {
            native.close()
            // native.skipToUrl({
            //   targetUrl: `https://feentry.zhuanzhuan.com/spam_cloudInspection?clientid=CloudInspectionPushResult&infoId=${this.info.infoId}`,
            //   needClose: '1'
            // });
          }, 800)
        })
        .catch((err) => {
          //  失败
          lego.send({
            pagetype: 'ZZUP_BONDINSPECTION',
            actiontype: 'SUBMIT_FAIL',
            backup: {
              uid: getCookie('uid'),
              err
            }
          })
          this.oneSubmit = true //等接口返回数据后可以再次提交
          Toast(err.message || err || '提交失败')
          console.error(err)
        })
    }
  },
  mounted() {
    native.setTitle({
      title: '保证金申诉'
    })
    this.init()
    const clipboard = new ClipboardJS('.copy-link')
    clipboard.on('success', function(e) {
      console.info('Action:', e.action)
      console.info('Text:', e.text)
      console.info('Trigger:', e.trigger)
      Toast(`保证金ID ${e.text} 复制成功`)
      e.clearSelection()
    })

    clipboard.on('error', function() {
      Toast('不支持自动复制，请手动复制')
    })
    console.log('-------this.from', this.from)
    native.wrap('setKeyboardFrameChangeCallback')((res) => {
      if (!res.kbState) return
      if (res.kbState === '1') {
        console.log('-------输入键盘出现')
      } else {
        console.log('-------输入键盘消失')
        if (this.$refs.input) this.$refs.input.blur()
        if (this.$refs.textArea) this.$refs.textArea.blur()
      }
    })
  },
  components: {
    // Skeleton,
    Stance,
    // Toast,
    zUpload: Upload
    // Dialog
  }
}
</script>

<style lang="less">
  @import './CommitInfo.less';
</style>
